/* eslint-disable max-classes-per-file */
import { MRole, MProfile } from '../auth.model'

export class MResidence {
    address: string

    city: any

    country: any

    email: string

    ethnicity: string

    id: string

    issuingState: any

    phone: string

    race: string

    smsApproval: string

    state: any

    stateId: string

    type: string

    userId: string

    zipCode: string

    constructor(residence: MResidence) {
        this.address = residence?.address || ''
        this.city = residence?.city?.code || ''
        this.country = residence?.country?.code || ''
        this.email = residence?.email || ''
        this.ethnicity = residence?.ethnicity || ''
        this.id = residence?.id || ''
        this.issuingState = residence?.issuingState?.code || ''
        this.phone = residence?.phone || ''
        this.race = residence?.race || ''
        this.smsApproval = residence?.smsApproval || ''
        this.state = residence?.state?.code || ''
        this.stateId = residence?.stateId || ''
        this.type = residence?.type || ''
        this.userId = residence?.userId || ''
        this.zipCode = residence?.zipCode || ''
    }
}

class MUser {
    firstName: string

    address: string

    city: string

    country: string

    dob: any

    gender: string

    height: string

    lastName: string

    middleName: string

    profileImage: string

    profileImageId: string

    state: any

    weight: string

    securityNumber: string

    zipCode: string

    constructor(user: any) {
        this.firstName = user?.profile?.firstName || ''
        this.address = user?.profile?.address || ''
        this.city = user?.profile?.city?.code || ''
        this.country = user?.profile?.country?.code || ''
        this.dob = user?.profile?.dob ? new Date(user?.profile?.dob) : null
        this.gender = user?.profile?.gender || ''
        this.height = user?.profile?.height || ''
        this.lastName = user?.profile?.lastName || ''
        this.middleName = user?.profile?.middleName || ''
        this.profileImage = user?.profile?.profileImage || ''
        this.profileImageId = user?.profile?.profileImageId || ''
        this.state = user?.profile?.state?.code || ''
        this.weight = user?.profile?.weight || ''
        this.zipCode = user?.profile?.zipCode || ''
        this.securityNumber = user?.securityNumber || ''
    }
}
export class MUserProfile extends MUser {
    primaryRole: MRole

    residences: MResidence[]

    POB: MResidence

    PR: MResidence

    PRArray: MResidence[]

    constructor(userProfile: MUserProfile) {
        super(userProfile)
        this.primaryRole = userProfile?.primaryRole
        this.residences = userProfile?.residences?.map(
            (item: MResidence) => new MResidence(item)
        )
        this.POB = new MResidence(
            userProfile?.residences?.filter((item) => item?.type === 'POB')?.[0]
        )
        this.PR = new MResidence(
            userProfile?.residences?.filter((item) => item?.type === 'PR')?.[0]
        )
        this.PRArray = userProfile?.residences
            ?.filter((item) => item?.type === 'PR')
            ?.map((item: MResidence) => new MResidence(item))
    }
}
